var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "h-100 d-flex flex-column"
  }, [_c('div', [_vm._t("icon")], 2), _c('b-card-text', {
    staticClass: "header-text"
  }, [_vm._t("header")], 2), _c('b-card-text', {
    staticClass: "name-text"
  }, [_vm._t("name")], 2), _c('b-card-text', {
    staticClass: "description-text"
  }, [_vm._t("description")], 2), _c('b-card-text', {
    staticClass: "mt-auto"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/event/icon/clock.svg"),
      "alt": "Clock icon"
    }
  }), _c('span', {
    staticClass: "date-text"
  }, [_vm._t("date")], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }